import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Select from 'react-select';
import ImageGallery from 'react-image-gallery';
import {
  handleFrameTasks,
  customSelectValue,
  sendDataForIframe,
} from 'shared/sharedMethods';
import { UPDATE_USER_DATA } from 'actions/actionTypes';
import PlaidLink from 'react-plaid-link';

import classNames from 'classnames';
import { makeRequest, dispatchAction, displayMessage } from 'actions';
import {
  Row,
  Col,
  Form,
  FormGroup,
  Modal,
  ControlLabel,
  FormControl,
  Button,
} from 'react-bootstrap';
import config from '../../../config';
import moment from 'moment';
import queryString from 'query-string';
import PaginationBox from 'shared/PaginationBox';
import SellerProductsListTable from 'sellers/products/SellerProductsListTable';
import SellerProductsSearchBox from 'sellers/products/SellerProductsSearchBox';
import async from 'async';
import SellerTransactionsTable from 'sellers/products/SellerTransactionsTable';
import formatNumbers from 'util/formatNumbers';
import { base64ToHex } from 'util/Utils';
import { v4 as uuidv4 } from 'uuid';
import { calculateTransactionPayoutAmount} from 'dashboard/transactions/transactionsPageMethods';

var payoutMethodOptions = [
  {
    label: 'Payout in Good Buy Bucks (store credit) and get bonus 10%',
    value: 'GoodBuyBucks',
  },
  {
    label: 'Payout to Donate/Non-profit ',
    value: 'Donation',
  },
  {
    label: 'Payout to your bank (via Dwolla)',
    value: 'DirectDeposit',
  },
];

class SellerProductsPage extends Component {
  static get contextTypes() {
    return {
      router: React.PropTypes.object.isRequired,
    };
  }

  constructor(props, context) {
    super(props, context);
    this.state = {
      plaidClientToken: null,
      currentPage: 1,
      currentRecord: {},
      showProductPreviewModal: false,
      showProductDetailsModal: false,
      showRequestChangesModal: false,
      ProductDetailsMessage: '',
      sellerTransactionsPage: 0,
      sellerTransactionsSortBy: '',
      PlaidPublicToken: false,
      sortBy: '',
      ShopifyCustomerID: _.get(this.props, ['location', 'query', 'customerid'], false),
      currentAvailableBalance: '',
      TransactionsForPayout: 'dataNotReceived',
      sellerTransactions: 'dataNotReceived',
      sellerProducts: 'dataNotReceived',
      currentScreen: 'ProductsTable',
      PayoutRequestID: '',
      PayoutMethod: {},
      searchType: 'OnSale',
      estimatedTimeToProcessItems: false,
      errors: {},
    };

    this.sendUpdateInformationEmail = _.throttle(this.sendUpdateInformationEmail, 5000, {
      leading: true,
      trailing: false,
    });
  }

  componentWillMount() {
    var self = this;
    this.getMarketSettingsData().then(function (marketSettings) {
       self.getEstimatedTimeToProcessItems({ marketSettings: marketSettings });
    });
    this.getTransactionsForPayoutRequest();
    this.searchTransactions();
    this.search({
      status: null,
      fromQuantity: 1,
      Statuses: ['Active'],
      sortBy: 'createdAt' + ':' + -1,
      addFields: ['PayoutAmount'],
    });
  }

  getMarketSettingsData() {
    return this.props
      .makeRequest(
        { Name: 'MarketSettings' },
        {
          endpoint: '/settings',
          not_display_error_message: true,
        }
      )
      .then(
        function (res) {
          this.setState({ marketSettings: _.get(res.data.data, [0, 'Data'], {}) });

          return _.get(res.data.data, [0, 'Data'], {});
        }.bind(this)
      )
      .catch((err) => {});
  }

  componentDidMount() {
    window.addEventListener('message', this.handleFrameTasks.bind(this));
    this.generateToken();
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.handleFrameTasks);
  }

  handleFrameTasks(event) {
    handleFrameTasks.call(this, { event: event, elementID: 'productsList' });
  }

  choosePlaidAccountOnSuccess(token, metadata) {
    console.log('on success', token, metadata);
    if (window.self == window.top && config.getEnvironmentName() !== 'local') {
      return;
    }
    this.setState({
      PlaidPublicToken: token,
      PlaidMetadata: metadata,
    });
    this.requestPayoutWithDirectDeposit();
  }

  generateToken() {
    const url = `${config.getEnvironment().IPABaseURL}/api/create-plaid-public-token`;
    const userId = base64ToHex(this.props.userReducer.user._id, { convertToHEXUUID: true })

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        userId: userId,
      })
    }).then((response) => {
      if (!response.ok) {
        return;
      }
      return response.json();
    }).then((data) => {
      if (data) {
        this.setState({ plaidClientToken: data.link_token });
      }
    }).catch((error) => {
      console.log('PlaidError', error);
    });
  };  

  requestPayoutWithDirectDeposit() {
    if (window.self == window.top && config.getEnvironmentName() !== 'local') {
      return;
    }
    this.setState({ pending: true, showWaitProcessingModal: true });
    this.props
      .makeRequest(
        {
          metadata: this.state.PlaidMetadata,
          action: 'SavePlaidItemForSeller',
          SellerID: this.props.userReducer.seller._id,
          PlaidPublicToken: this.state.PlaidPublicToken,
          DirectDepositAmount: this.state.DirectDepositAmount,
          PayoutMethod: 'DirectDeposit',
          PayoutRequestDate: this.state.PayoutRequestDate,
          PayoutAmount: this.calculatePayoutAmount({ format: true }),
          UserID: _.get(this.props.userReducer.user, '_id', ''),
          recordIDs: _.map(this.state.TransactionsForPayout, function (transaction) {
            return transaction._id;
          }),
        },
        {
          endpoint: '/process-action',
          type: 'post',
        }
      )
      .then((response) => {
        console.log('response 1', response);
        sendDataForIframe.call(this, 'productsList');
        this.setState(
          {
            PlaidPublicToken: false,
            PayoutRequestID: response.data.PayoutRequestID,
            sellerTransactions: 'dataNotReceived',
            sellerProducts: 'dataNotReceived',
            currentScreen: 'PayoutRequestSuccess',
            pending: false,
            showWaitProcessingModal: false,
          },
          function () {
            this.searchBox = false;
            /* to workaround issue when this.searchBox is linked to the unmounted Search box component*/
            this.searchTransactions();
            this.getUserData(this.props.userReducer.user.ShopifyCustomerID); /*update user data */
            this.search();
          }
        );
      })
      .catch((error) => {
        sendDataForIframe.call(this, 'productsList');
        this.setState({
          pending: false,
          showWaitProcessingModal: false,
          PlaidPublicToken: false,
          DirectDepositAmount: '',
          currentScreen: 'ProductsTable',
        });
        console.log('error', error);
      });
  }

  createPlaidItemOnExit(err, metadata) {
    console.log('on exit', err, metadata);
    sendDataForIframe.call(this, 'productsList');
    // The user exited the Link flow.
    if (err != null) {
      // The user encountered a Plaid API error prior to exiting.
    }
  }

  getUserData(ShopifyCustomerID) {
    var methodData = {
      endpoint: '/get-user-data-with-query',
      success_event: UPDATE_USER_DATA,
      type: 'post',
    };

    return this.props
      .makeRequest({ ShopifyCustomerID: ShopifyCustomerID }, methodData)
      .then((res) => {
        console.log('in user update', res.data);

        return res.data;
      });
  }

  getEstimatedTimeToProcessItems(params) {
    var self = this;

    async.waterfall(
      [
        function (done) {
          self.props
            .makeRequest(
              {
                perPage: 1,
                Statuses: ['Received'],
                SellerID: self.props.userReducer.seller._id,
                sortBy: 'ServiceStartTime:1',
              },
              {
                endpoint: '/get-pickups',
                not_display_success_message: true,
              }
            )
            .then(function (response) {
              console.log('seller services', response.data.data);
              var earliestSellerService = _.get(response.data.data, '0', false);

              done(null, earliestSellerService);
            })
            .catch((err) => {
              done(err);
            });
        },
        function (earliestSellerService, done) {
          console.log('earliestSellerServiceDate', earliestSellerService);
          if (_.get(earliestSellerService, 'ServiceStartTime')) {
            self.props
              .makeRequest(
                {
                  Statuses: ['Received'],
                  //   from: moment(_.get(earliestSellerService,'ServiceStartTime')).toDate(),
                  Markets: [_.get(earliestSellerService, 'MarketName')],
                  PalletIDExists: false,
                  PartnerIDExists: false,
                  sortBy: 'ServiceStartTime:1',
                  all: true,
                },
                {
                  endpoint: '/get-pickups',
                  not_display_success_message: true,
                }
              )
              .then(function (response) {
                var otherSellerServices = _.reject(response.data.data, (item) => {
                  return item.SellerID == self.props.userReducer.seller._id;
                });
                var otherSellerServices = _.reject(otherSellerServices, (item) => {
                  //   if (moment(_.get(earliestSellerService,'ServiceStartTime')).isSame(moment(_.get(item,'ServiceStartTime')),'minute')){
                  var ReceivedStatusChangeLog = _.findLast(
                    _.get(item, 'ChangeLog', []),
                    (changeLog) => {
                      if (
                        _.get(changeLog, 'FieldChanged', '') == 'Status' &&
                        _.get(changeLog, 'To', '') == 'Received'
                      ) {
                        return true;
                      }
                    }
                  );
                  var sellerServiceReceivedStatusChangeLog = _.findLast(
                    _.get(earliestSellerService, 'ChangeLog', []),
                    (changeLog) => {
                      if (
                        _.get(changeLog, 'FieldChanged', '') == 'Status' &&
                        _.get(changeLog, 'To', '') == 'Received'
                      ) {
                        return true;
                      }
                    }
                  );
                  if (ReceivedStatusChangeLog && sellerServiceReceivedStatusChangeLog) {
                    return moment(sellerServiceReceivedStatusChangeLog.createdAt).isBefore(
                      moment(ReceivedStatusChangeLog.createdAt),
                      'second'
                    );
                  }
                  //     }
                });
                var dataToCheck = {
                  numberOfServicesToProcess: otherSellerServices.length,
                };
                var matchingCondition = _.find(
                  _.get(
                    params.marketSettings,
                    [
                      _.get(earliestSellerService, 'MarketName', 'Denver'),
                      'EstimatedProcessingTime',
                    ],
                    []
                  ),
                  function (item) {
                    var correctStatements = _.filter(item.conditions, function (condition) {
                      return (
                        !_.isUndefined(config.operatorsMap[condition.operator]) &&
                        config.operatorsMap[condition.operator](
                          _.get(dataToCheck, [condition.field], 'n/a'),
                          condition.value
                        )
                      );
                    });
                    if (correctStatements.length == item.conditions.length) {
                      return true;
                    }
                  }
                );

                self.setState({ estimatedTimeToProcessItems: _.get(matchingCondition, 'value') });
                done(null);
              })
              .catch((err) => {
                done(err);
              });
          } else {
            self.setState({ estimatedTimeToProcessItems: false });
          }
        },
      ],
      function (err) {}
    );
  }

  getTransactionsForPayoutRequest() {
    var self = this;
    var methodData = {
      endpoint: '/transactions',
    };

    this.props
      .makeRequest(
        {
          toFD: moment().endOf('day').toISOString(),
          Statuses: ['Sold'],
          addFields: ['FundsAvailableForPaymentAt'],
          SellerID: this.props.userReducer.seller._id,
          all: true,
        },
        methodData
      )
      .then(function (response) {
        const currentDay = moment();
        var transactionsForPayout = _.reject(response.data.data, function (transaction) {
          if (moment(transaction.FundsAvailableForPaymentAt).isAfter(currentDay, 'day')) {
            return true;
          }
        });
        self.setState({ TransactionsForPayout: transactionsForPayout });
      })
      .catch((err) => {});
  }

  showProductDetailsModal(message) {
    this.setState({
      showProductDetailsModal: true,
      ProductDetailsMessage: message,
    });
  }

  showRequestChangesModal(row) {
    this.setState({
      showRequestChangesModal: true,
      currentRecord: {
        ...row,
        RequestedChanges: '',
      },
    });
  }

  showProductPreviewModal(row) {
    var published = true;

    if (row.Status == 'Inactive') {
      var changeLogFound = _.find(_.get(row, 'ChangeLog', []), function (log) {
        if (log.FieldChanged == 'Status' && log.From == 'Inactive' && log.To == 'Active') {
          return true;
        }
      });

      if (_.isUndefined(changeLogFound)) {
        /* if product is not yet published */
        published = false;
      }
    }
    this.setState({
      showProductPreviewModal: true,
      currentRecord: {
        ...row,
        Images: _.map(_.get(row, 'OriginalImages', []), (item) => {
          return {
            original: item.URL,
            thumbnail: item.URL,
            originalTitle: _.get(item, 'Caption', ''),
            thumbnailTitle: _.get(item, 'Caption', ''),
          };
        }),
        published: published,
      },
    });
  }

  requestPayoutWithSelectedMethod() {
    console.log('requestPayoutWithSelectedMethod');
    if (window.self == window.top && config.getEnvironmentName() !== 'local') {
      return;
    }
    this.setState({ pending: true });

    var methodData = {
      endpoint: '/transactions-process-action',
      type: 'post',
      //  messageCode: 'Payout request was processed'
    };
    var recordIDs = _.map(this.state.TransactionsForPayout, function (transaction) {
      return transaction._id;
    });
    var requestData = {
      PayoutMethod: this.state.PayoutMethod.value,
    };

    if (_.includes(requestData.PayoutMethod, 'Donate')) {
      requestData.PayoutMethod = 'Donate';
      requestData.PaymentData = { Donate: { email: this.state.PayoutMethod.value.slice(6) } };
    }
    this.props
      .makeRequest(
        {
          ...requestData,
          action: 'RequestPayout',
          PayoutRequestID: this.state.PayoutRequestID,
          PayoutRequestDate: this.state.PayoutRequestDate,
          PayoutAmount: this.calculatePayoutAmount({ format: true }),
          PayoutMethod: _.includes(_.get(this.state.PayoutMethod, 'value', ''), 'Donate')
            ? 'Donate'
            : _.get(this.state.PayoutMethod, 'value', ''),
          PayoutMethodDetails: this.getPayoutMethodDetails(),
          UserID: _.get(this.props.userReducer.user, '_id', ''),
          recordIDs: recordIDs,
        },
        methodData
      )
      .then(() => {
        this.setState(
          {
            TransactionsForPayout: 'dataNotReceived',
            sellerTransactions: 'dataNotReceived',
            sellerProducts: 'dataNotReceived',
            currentScreen: 'PayoutRequestSuccess',
            pending: false,
          },
          function () {
            this.searchBox = false;
            /* to workaround issue when this.searchBox is linked to the unmounted Search box component*/
            this.searchTransactions();
            this.search();
          }
        );
      })
      .catch((err) => {
        this.setState({ pending: false });
      });
  }

  onSortChange(field, sortOrder) {
    this.setState({ sortBy: field + ':' + (sortOrder == 'asc' ? 1 : -1) }, function () {
      this.refs.pagination.resetPagination();
      this.search();
    });
  }

  onTransactionsSortChange(field, sortOrder) {
    this.setState(
      { sellerTransactionsSortBy: field + ':' + (sortOrder == 'asc' ? 1 : -1) },
      function () {
        this.refs.sellerTransactionsPagination.resetPagination();
        this.searchTransactions();
      }
    );
  }

  sendUpdateInformationEmail() {
    var methodData = {
      type: 'post',
      endpoint: '/process-action',
      not_display_success_message: true,
    };

    return this.props
      .makeRequest(
        {
          action: 'SendUpdateSellerInformationEmail',
          TransactionID: this.state.PayoutRequestID,
          SellerDisplayName: _.get(this.props.userReducer.seller, 'DisplayName', ''),
        },
        methodData
      )
      .then((res) => {
        this.setState({ currentScreen: 'PayoutRequestSuccess' });
      })
      .catch((err) => {});
  }

  calculatePayoutAmount(params = {}) {
     const self = this;
    var totalPayoutAmount = _.reduce(
      this.state.TransactionsForPayout,
      function (totalPayout, transaction) {
         if (transaction.Type == 'Sale') {
          if (_.isUndefined(transaction.SaleData.PayoutPercentage)) {
            return totalPayout;
          }

          const payoutAmount = calculateTransactionPayoutAmount(transaction,  self.props.appData.FeatureFlags);
           totalPayout +=  payoutAmount;
        } else if (transaction.Type == 'Credit') {
          totalPayout += formatNumbers.unformat(formatNumbers.toFixed(transaction.Amount, 2));
        } else if (transaction.Type == 'Fee' || transaction.Type == 'PickupFee') {
          totalPayout -= formatNumbers.unformat(formatNumbers.toFixed(transaction.Amount, 2));
        }

        return totalPayout;
      },
      0
    );

    if (
      _.get(params, 'PayoutMethod', _.get(this.state.PayoutMethod, ['value'], '')) ==
        'GoodBuyBucks' &&
      params.bonusAmount
    ) {
      totalPayoutAmount += params.bonusAmount;
    }
    totalPayoutAmount = formatNumbers.unformat(formatNumbers.toFixed(totalPayoutAmount, 2));
    if (params.format) {
      return totalPayoutAmount >= 0
        ? formatNumbers.formatMoney(totalPayoutAmount)
        : '-$' + Math.abs(totalPayoutAmount);
    } else {

      return totalPayoutAmount;
    }
  }

  getPayoutMethodDetails(params = {}) {
    if (_.get(this.state.PayoutMethod, 'value', '') == 'Check') {
      /* display Pickup address */
      return (
        _.get(params, 'prepend', '') +
        _.get(this.props.userReducer.seller, 'PickupAddress.Street', '') +
        ' ' +
        _.get(this.props.userReducer.seller, 'PickupAddress.City', '') +
        ' ' +
        _.get(this.props.userReducer.seller, 'PickupAddress.Zip', '')
      );
    } else if (_.get(this.state.PayoutMethod, 'group', '') == 'Donation') {
      return (
        (params.prepend ? ' (' : '') +
        _.get(this.state.PayoutMethod, 'label', '') +
        (params.prepend ? ')' : '')
      );
      // payoutMethodDetails = _.get(this.props.userReducer.seller, ['PaymentData', _.get(this.props.userReducer.seller, 'PayoutMethod', ''), 'email'], '')
    } else if (
      params.PayoutMethod == 'DirectDeposit' ||
      _.get(this.state.PayoutMethod, 'value', '') == 'DirectDeposit'
    ) {
      if (
        _.get(this.props.userReducer, 'seller.DwollaServiceData.FundingSources.0.AccountName', '')
      ) {
        return (
          (params.prepend ? ' (' : '') +
          (_.get(
            this.props.userReducer,
            'seller.DwollaServiceData.FundingSources.0.AccountName',
            ''
          ) +
            ' / ' +
            _.get(
              this.props.userReducer,
              'seller.DwollaServiceData.FundingSources.0.AccountMask',
              ''
            )) +
          (params.prepend ? ')' : '')
        );
      } else {
        return '';
      }
    } else {
      return '';
    }
  }

  displayPayoutRequestForm() {
    const { EnablePayoutScaleV3 } =  this.props.appData.FeatureFlags;
    return (
      <div className="pickup-form">
        {_.includes(
          ['Donation', 'GoodBuyBucks'],
          _.get(this.state.PayoutMethod, ['value'], '')
        ) && (
          <div>
            {_.get(this.state.PayoutMethod, ['value'], '') == 'GoodBuyBucks' && (
              EnablePayoutScaleV3 ?
                <div className="top20">
                  {`We are sending you ${this.calculatePayoutAmount({ format: true })}`}
                </div> :
              <div className="top20">
                <span>
                  {'We are sending you a gift card for ' +
                    formatNumbers.formatMoney(
                      this.calculatePayoutAmount() + this.state.PayoutMethodBonus
                    ) +
                    ' (' +
                    this.calculatePayoutAmount({ format: true }) +
                    ' balance '}
                </span>
                <span className="pink">
                  {'plus a $' +
                    formatNumbers.toFixed(this.state.PayoutMethodBonus, 2).replace(/\.00$/, '') +
                    ' bonus!'}
                </span>
              </div>

            )}

            {_.get(this.state.PayoutMethod, ['value'], '') == 'Donation' && (
              <Row className="pbot25">
                <Col className="top20" md={7} xs={12}>
                  <Select
                    style={this.state.errors['PayoutMethod'] ? { border: '1px solid red' } : {}}
                    onFocus={(e) =>
                      this.setState({
                        errors: {
                          ...this.state.errors,
                          PayoutMethod: false,
                        },
                      })
                    }
                    valueComponent={customSelectValue.bind(this)}
                    className={classNames({
                      'with-custom-value': this.state.PayoutMethod,
                    })}
                    clearable={false}
                    selectedOptions
                    placeholder={'Choose a lucky recipient'}
                    options={_.filter(
                      _.get(
                        this.state.marketSettings,
                        [_.get(this.props.userReducer.seller, 'MarketName'), 'PayoutOptions'],
                        []
                      ),
                      { group: 'Donation' }
                    )}
                    onChange={(option) => {
                      this.setState({ PayoutMethod: option ? option : false }, function () {
                        if (option) {
                          this.setState({
                            currentScreen: 'PayoutRequestConfirmation',
                          });
                        }
                      });
                    }}
                    value={
                      _.get(this.state.PayoutMethod, 'value') == 'Donation'
                        ? ''
                        : this.state.PayoutMethod
                    }
                  />
                </Col>
              </Row>
            )}

            <Row className="top30">
              <Col className="" md={7} sm={8} xs={12}>
                <Button
                  disabled={this.state.pending}
                  className="btn btn-default"
                  onClick={(event) => {
                    this.searchBox = false;
                    /* to workaround issue when this.searchBox is linked to the unmounted Search box component*/
                    this.setState({
                      PlaidPublicToken: false,
                      DirectDepositAmount: '',
                      currentScreen: 'ProductsTable',
                    });
                  }}
                >
                  Cancel
                </Button>

                <Button
                  disabled={this.state.pending}
                  className="btn btn-primary pull-right"
                  onClick={(event) => {
                    this.setState({
                      currentScreen: 'PayoutRequestConfirmation',
                    });
                  }}
                >
                  Confirm
                </Button>
              </Col>
            </Row>
          </div>
        )}

        {_.get(this.state.PayoutMethod, ['value'], '') == 'DirectDeposit' && (
          <div>
            {this.state.PlaidPublicToken2 ? (
              <Col className="" style={{ maxWidth: 600 }} xs={10}>
                <div style={{ paddingTop: 15, paddingLeft: 10, height: 50, textAlign: 'left' }}>
                  <span>Bank Direct Deposit Amount</span>
                  <span className="pull-right pright10">
                    {formatNumbers.formatMoney(this.state.DirectDepositAmount)}
                  </span>
                </div>

                <FormControl
                  style={{ height: 50, borderLeft: 'none', borderRight: 'none', borderRadius: 0 }}
                  defaultValue={this.state.DirectDepositAmount}
                  placeholder={'Direct deposit amount'}
                  onChange={(e) =>
                    this.setState({ DirectDepositAmount: e.target.value }, function () {
                      sendDataForIframe.call(this, 'productsList');
                    })
                  }
                  type="text"
                />

                <div
                  style={{
                    backgroundColor: '#ededf4',
                    fontSize: 14,
                    paddingTop: 5,
                    paddingLeft: 10,
                    height: 50,
                    textAlign: 'left',
                  }}
                >
                  Bank direct deposits are available when requesting more than $2, with a $2
                  processing fee for transactions under $10
                </div>

                <div style={{ paddingTop: 15, paddingLeft: 10, height: 50, textAlign: 'left' }}>
                  <span>Current Balance</span>
                  <span className="pull-right pright10">
                    {this.calculatePayoutAmount({ format: true })}
                  </span>
                </div>
              </Col>
            ) : (
              <Col className="" style={{ maxWidth: 600 }} md={7} sm={7} xs={10}>
                <div className="bot20 top20">
                  We will redirect you to Plaid to securely link your bank account
                </div>
              </Col>
            )}

            <Col className="" style={{ maxWidth: 600, marginTop: 30 }} md={10} sm={10} xs={10}>
              <Button
                style={{}}
                disabled={this.state.pending}
                className="btn btn-default pull-left"
                onClick={(event) => {
                  this.searchBox = false;
                  /* to workaround issue when this.searchBox is linked to the unmounted Search box component*/
                  this.setState({
                    PlaidPublicToken: false,
                    DirectDepositAmount: '',
                    currentScreen: 'ProductsTable',
                  });
                }}
              >
                Cancel
              </Button>

              {this.state.PlaidPublicToken2 ? (
                <Button
                  disabled={true}
                  className="btn btn-primary pull-right"
                  onClick={(event) => {
                    return;
                    // this.confirmPayment();
                  }}
                >
                  Confirm
                </Button>
              ) : (
                this.state.plaidClientToken ? (
                  <PlaidLink
                    token={this.state.plaidClientToken}
                    env={config.getEnvironment().plaid.mode}
                    selectAccount={true}
                    product={['auth']}
                    className="btn btn-primary pull-right"
                    onEvent={(event) => {
                      if (_.get(data, 'view_name') == 'CONSENT') {
                        sendDataForIframe.call(this, 'productsList', { height: 400 });
                      }
                    }}
                    style={{ float: 'right' }}
                    onExit={this.createPlaidItemOnExit.bind(this)}
                    onSuccess={this.choosePlaidAccountOnSuccess.bind(this)}
                  >
                    Confirm
                  </PlaidLink>
                ) : (
                  <div>Loading...</div>
                )
              )}
            </Col>
          </div>
        )}
      </div>
    );
  }

  displayPayoutRequestConfirmation() {
    return (
      <div>
        <Form className="pickup-form clearfix">
          <Row className="left0 right0">
            <Col xs={12}>
              <FormGroup>
                {this.state.PayoutMethod.value == 'GoodBuyBucks' && (
                  <div>
                    <div className="top20">Cha-Ching!</div>
                    <div className="top20">Thanks, {this.props.userReducer.user.firstName}</div>
                  </div>
                )}

                {this.state.PayoutMethod.group == 'Donation' && (
                  <div>
                    <div className="top20">
                      Thanks for your donation, {this.props.userReducer.user.firstName}
                    </div>
                  </div>
                )}

                <div className="top20">Please verify your payout details:</div>

                <div>
                  <span className="left20 top10 right20">-</span>
                  <span>
                    Payout Amount:{' '}
                    {this.calculatePayoutAmount({
                      bonusAmount: this.state.PayoutMethodBonus,
                      format: true,
                    })}
                  </span>
                </div>

                <div>
                  <span className="left20 top10 right20">-</span>
                  <span>
                    Payout Method:{' '}
                    {config.payoutMethodsMap[
                      _.includes(_.get(this.state.PayoutMethod, 'value', ''), 'Donate')
                        ? 'Donate'
                        : _.get(this.state.PayoutMethod, 'value', '')
                    ] + this.getPayoutMethodDetails({ prepend: ': ' })}
                  </span>
                </div>

                {this.state.PayoutMethod.group !== 'Donation' && (
                  <div className="top20">
                    {this.state.PayoutMethod.value == 'DirectDeposit'
                      ? 'Transfer will be initiated immediately, please allow 3-5 business days for the funds to appear in your account.'
                      : 'Your Good Buy Bucks will be sent to your email ' +
                        _.get(this.props.userReducer, ['user', 'email'], '') +
                        ' '}
                    Please click{' '}
                    <a
                      target="_blank"
                      href={
                        'https://intercom.help/good-buy-gear/frequently-asked-questions/sellers/how-does-the-payout-process-work'
                      }
                    >
                      here
                    </a>{' '}
                    for more details on how the process works.
                  </div>
                )}
              </FormGroup>

              <FormGroup></FormGroup>
            </Col>
          </Row>

          <Row className="left0 right0">
            <FormGroup>
              <Col md={7} sm={8} xs={12}>
                <Button
                  disabled={this.state.pending}
                  className="btn btn-default"
                  onClick={() => {
                    this.searchBox = false;
                    /* to workaround issue when this.searchBox is linked to the unmounted Search box component*/
                    this.setState({ PlaidPublicToken: false, currentScreen: 'ProductsTable' });
                  }}
                >
                  Cancel
                </Button>

                <Button
                  disabled={this.state.pending}
                  className="btn btn-primary pull-right"
                  onClick={() => {
                    if (this.state.PayoutMethod.value == 'DirectDeposit') {
                      this.requestPayoutWithDirectDeposit();
                    } else {
                      this.requestPayoutWithSelectedMethod();
                    }
                  }}
                >
                  Confirm & Issue Payout
                </Button>
              </Col>
            </FormGroup>
          </Row>
        </Form>
      </div>
    );
  }

  displayPayoutRequestSuccess() {
    return (
      <div>
        <Form className="pickup-form clearfix" horizontal>
          <Row className="left0 right0">
            <Col xs={12} className="top20">
              <FormGroup>
                {_.get(this.state.PayoutMethod, 'value') == 'DirectDeposit' ? (
                  <div>
                    <div className="top20">Success!</div>
                    <div className="top20">
                      {'Your balance of ' +
                        this.calculatePayoutAmount({ format: true }) +
                        ' has been successfully transfered via Direct Deposit to your bank account ' +
                        (_.get(
                          this.props.userReducer,
                          'seller.DwollaServiceData.FundingSources.0.AccountName',
                          ''
                        )
                          ? '(' +
                            _.get(
                              this.props.userReducer,
                              'seller.DwollaServiceData.FundingSources.0.AccountName',
                              ''
                            ) +
                            ' / ' +
                            _.get(
                              this.props.userReducer,
                              'seller.DwollaServiceData.FundingSources.0.AccountMask',
                              ''
                            ) +
                            ')'
                          : ')') +
                        '. Please allow for 3-5 business days for the funds to appear in your account.'}
                    </div>
                    <div className="top20 font-size-14">
                      Transaction ID: {this.state.PayoutRequestID}
                    </div>
                  </div>
                ) : (
                  <div>
                    <div className="top20">Thank you!</div>
                    <div className="top20">Your request has been successfully submitted</div>
                    <div className="top20 font-size-14">
                      Transaction ID: {this.state.PayoutRequestID}
                    </div>
                  </div>
                )}

                <Button
                  disabled={this.state.pending}
                  className="btn btn-primary top20"
                  onClick={(event) => {
                    this.searchBox = false;
                    /* to workaround issue when this.searchBox is linked to the unmounted Search box component*/
                    this.setState(
                      {
                        TransactionsForPayout: 'dataNotReceived',
                        DirectDepositAmount: '',
                        PlaidMetaData: {},
                      },
                      function () {
                        top.window.location.href = 'https://goodbuygear.com/collections/all';
                      }
                    );
                  }}
                >
                  Shop now
                </Button>
              </FormGroup>
            </Col>
          </Row>
        </Form>
      </div>
    );
  }

  displayTransactionsTable() {
    if (
      this.state.sellerTransactions == 'dataNotReceived' ||
      this.state.sellerTransactionsTotal == 0
    ) {
      return null;
    } else {
      return (
        <div className="top20">
          <div className="font-size-20 navyBlue">Fees</div>

          <SellerTransactionsTable
            onSortChange={this.onTransactionsSortChange.bind(this)}
            sellerTransactions={this.state.sellerTransactions}
            search={this.searchTransactions.bind(this)}
            {...this.props}
          ></SellerTransactionsTable>

          <PaginationBox
            currentPage={this.state.sellerTransactionsPage}
            perPage={5}
            ref={'sellerTransactionsPagination'}
            total={this.state.sellerTransactionsTotal}
            search={this.searchTransactions.bind(this)}
          ></PaginationBox>
        </div>
      );
    }
  }

  displayPayoutButtons() {
    const { EnablePayoutScaleV3 } = this.props.appData.FeatureFlags;
    const payoutMethodBonus = EnablePayoutScaleV3 ? '' : (10 * this.calculatePayoutAmount()) / 100;
    const payoutAmount = this.calculatePayoutAmount({
      format: true,
      PayoutMethod: 'GoodBuyBucks',
      bonusAmount: payoutMethodBonus,
    });
    const buttonLabel = `${payoutAmount} ${EnablePayoutScaleV3 ? '' : '(10% bonus)'}`;
    return (
      <div className="buttons">
        <Button
          disabled={
            this.state.pending ||
            (window.self == window.top && config.getEnvironmentName() !== 'local')
          }
          className="btn btn-primary"
          style={{ minHeight: '73px' }}
          onClick={() => {
            const self = this;
            setTimeout(function () {
              self.setState({
                PayoutMethod: _.find(payoutMethodOptions, { value: 'GoodBuyBucks' }),
                PayoutRequestID: uuidv4(),
                PayoutMethodBonus: !EnablePayoutScaleV3 ? payoutMethodBonus : undefined,
                PayoutRequestDate: moment().toISOString(),
                currentScreen: 'PayoutRequestForm',
              });
            }, 300);
          }}
        >
          GoodBuy Bucks
          <span>{buttonLabel}</span>
        </Button>

        {_.get(
          this.props.userReducer,
          'seller.DwollaServiceData.FundingSources.0.AccountName',
          false
        ) ? (
          <Button
            disabled={
              this.state.pending ||
              (window.self == window.top && config.getEnvironmentName() !== 'local')
            }
            className="btn btn-primary"
            onClick={(event) => {
              var self = this;

              self.setState({
                PayoutMethod: _.find(payoutMethodOptions, { value: 'DirectDeposit' }),
                PayoutRequestID: uuidv4(),
                PayoutRequestDate: moment().toISOString(),
                currentScreen: 'PayoutRequestConfirmation',
              });
            }}
          >
            Direct Deposit
            <span>{this.calculatePayoutAmount({ format: true })}</span>
          </Button>
        ) : (
          <div>
            {window.self == window.top && config.getEnvironmentName() !== 'local' ? null : (
              this.state.plaidClientToken ? (
              <PlaidLink
                token={this.state.plaidClientToken}
                env={config.getEnvironment().plaid.mode}
                selectAccount={true}
                product={['auth']}
                className="btn btn-primary"
                onEvent={(event, data) => {
                  if (_.get(data, 'view_name') == 'CONSENT') {
                    sendDataForIframe.call(this, 'productsList', { height: 400 });
                  } else if (event == 'EXIT') {
                    sendDataForIframe.call(this, 'productsList');
                  }
                  console.log('onEvent', event, data);
                }}                
                onExit={this.createPlaidItemOnExit.bind(this)}
                onSuccess={this.choosePlaidAccountOnSuccess.bind(this)}
              >
                Direct Deposit
                <span>{this.calculatePayoutAmount({ format: true })}</span>
              </PlaidLink>
            ) : (
              <div>Loading...</div>
            ))}
          </div>
        )}

        <Button
          disabled={
            this.state.pending ||
            (window.self == window.top && config.getEnvironmentName() !== 'local')
          }
          className="btn btn-primary"
          onClick={(event) => {
            var self = this;

            setTimeout(function () {
              self.setState({
                PayoutMethod: _.find(payoutMethodOptions, { value: 'Donation' }),
                PayoutRequestID: uuidv4(),
                PayoutRequestDate: moment().toISOString(),
                currentScreen: 'PayoutRequestForm',
              });
            }, 300);
          }}
        >
          Donate
          <span>{this.calculatePayoutAmount({ format: true })}</span>
        </Button>
      </div>
    );
  }

  displayCurrentBalance() {

    if (this.state.TransactionsForPayout == 'dataNotReceived') {
      return null;
    } else {
      var totalPayoutAmount = this.calculatePayoutAmount();

      return (
        <div className="seller-payout">
          <img
            src={
              (config.getEnvironmentName() == 'local' ? 'http://localhost:3037' : '') +
              '/theme/assets/seller_payout.svg'
            }
          />

          <div className="payout-price">
            <span>
              {totalPayoutAmount >= 0
                ? formatNumbers.formatMoney(totalPayoutAmount)
                : '-$' + Math.abs(totalPayoutAmount)}
              <img
                className="info-icon"
                src={
                  (config.getEnvironmentName() == 'local' ? 'http://localhost:3037' : '') +
                  '/theme/assets/seller_info.svg'
                }
              />
              <div className="info-text">
                Make sure to take a peek at the payout breakdown + service fees below for
                explanations and answers to questions
              </div>
            </span>
          </div>

          {parseFloat(totalPayoutAmount) == 0 && (
            <div className="payout-details">
              <h3>Earn Cash on Your Baby & Kid Gear</h3>
              <div className="text">
                Looks like you haven't sold anything yet, let us do the work for you.
              </div>
              <a
                target="_blank"
                href={'https://goodbuygear.com/pages/schedule-a-white-glove-pickup-service'}
                className="btn btn-primary"
              >
                Schedule a Service
              </a>
            </div>
          )}

          {parseFloat(totalPayoutAmount) > 0 && parseFloat(totalPayoutAmount) < 5 && (
            <div className="payout-details">
              <h3>You're Earning Cash on Your Gear</h3>
              <div className="text">
                Payout options will appear when your balance reaches $5.
                <br />
                <a
                  target="_blank"
                  href={'https://goodbuygear.com/pages/schedule-a-white-glove-pickup-service'}
                >
                  Schedule another service
                </a>{' '}
                to help reach $5!
              </div>
            </div>
          )}

          {parseFloat(totalPayoutAmount) > 5 && (
            <div className="payout-details details-available">
              <h3>Cha-ching, It's Time to Get Your Payout</h3>
              <div className="text">
                Looking for a bigger payout?{' '}
                <a
                  target="_blank"
                  href={'https://goodbuygear.com/pages/schedule-a-white-glove-pickup-service'}
                >
                  Schedule another service
                </a>
                .
              </div>
              {this.displayPayoutButtons()}
            </div>
          )}

          {parseFloat(totalPayoutAmount) < 5 && config.getEnvironmentName() == 'local' && (
            <div className="payout-details ptop20">{this.displayPayoutButtons()}</div>
          )}
        </div>
      );
    }
  }

  search(params = {}) {
    var queryParams = {
      status: 'all',
      useAnalyticDatabase: true,
      addFields: ['LatestSaleTransaction', 'FundsAvailableForPaymentAt', 'PayoutAmount'],
    };
    var methodData = {
      endpoint: '/products',
      not_display_success_message: true,
    };
    var searchBoxParams = this.searchBox ? this.searchBox.getSearchParams(params) : {};
    _.extend(queryParams, params);

    _.extend(queryParams, searchBoxParams);
    if (this.state.sortBy) {
      queryParams.sortBy = this.state.sortBy;
    } else {
      queryParams.sortBy = 'TransactionOrProductStatus' + ':' + -1;
      /* when sorting by TransactionOrProductStatus some products are not displayed for some reason */
    }
    if (_.get(params, 'displayCurrentPage') && this.refs.pagination) {
      queryParams.page = _.get(this.refs.pagination, 'state.currentPage', 0) + 1;
      /* when refreshing the table after user changes some product data */
    }
    queryParams.sortBySecondary = '_id:-1';
    /* without secondary sort query, the order of documents with the same fields is not guaranteed across pages */

    queryParams.perPage = 5;
    queryParams.includeSaleTransactionsInTotalCount = true;
    queryParams.lookup = ['SellerID'];
    queryParams.listingStatuses = ['Listings'];
    queryParams.SellerID = this.props.userReducer.seller._id;

    return this.props
      .makeRequest(queryParams, methodData)
      .then((res) => {
        if (this.refs.pagination && _.isUndefined(queryParams.page)) {
          this.refs.pagination.resetPagination();
        }

        let dataToSet = { sellerProducts: res.data.data, sellerProductsTotal: res.data.total, requestPending:false };

       if(params.searchType) {
        dataToSet.searchType = params.searchType;
        }

       this.setState(dataToSet);
        sendDataForIframe.call(this, 'productsList');
        return true;
      })
      .catch((err) => {
        sendDataForIframe.call(this, 'productsList');
      });
  }

  searchTransactions(params = {}) {
    var self = this;
    var queryParams = params;
    queryParams.useAnalyticDatabase = true;
    var methodData = {
      endpoint: '/transactions',
      not_display_success_message: true,
    };

    if (this.state.sellerTransactionsSortBy) {
      queryParams.sortBy = this.state.sellerTransactionsSortBy;
    } else {
      queryParams.sortBy = 'FulfilledAt' + ':' + -1;
    }
    queryParams.sortBySecondary = '_id:-1';
    /* without secondary sort query, the order of documents with the same fields is not guaranteed across pages */

    queryParams.perPage = 5;
    queryParams.SellerID = this.props.userReducer.seller._id;
    queryParams.Statuses = ['Sold', 'Paid', 'PendingPayout'];
    queryParams.Types = ['PickupFee', 'Fee', 'Credit'];

    return this.props
      .makeRequest(queryParams, methodData)
      .then((res) => {
        if (this.refs.sellerTransactionsPagination && _.isUndefined(queryParams.page)) {
          this.refs.sellerTransactionsPagination.resetPagination();
        }
        self.setState({
          sellerTransactions: res.data.data,
          sellerTransactionsTotal: res.data.total,
        });
        sendDataForIframe.call(this, 'productsList');
      })
      .catch((err) => {});
  }

  publishProduct(productID) {
    var self = this;

    self.props
      .makeRequest(
        { PublishedBySeller: true },
        {
          messageData: { '#1#': 'Product' },
          not_display_success_message: true,
          endpoint: '/products/' + encodeURIComponent(productID),
          type: 'patch',
        }
      )
      .then((response) => {
        self.search({ displayCurrentPage: true, currentRecord: {} });
        this.setState({ showProductPreviewModal: false });
      })
      .catch((err) => {});
  }

  sendProductRequestChangesEmail() {
    var self = this;

    if (!this.state.currentRecord.RequestedChanges) {
      this.setState({ showRequestChangesModal: false, pending: false });

      return this.props.displayMessage({
        messageType: 'warning',
        messagePosition: 'bc',
        messageCode: 'Please, specify changes that must done',
      });
    }
    self.props
      .makeRequest(
        {
          action: 'SendProductRequestChangeEmail',
          ProductName: this.state.currentRecord.ProductName,
          RequestedChanges: this.state.currentRecord.RequestedChanges,
          ShopifyProductID: this.state.currentRecord.ShopifyProductID,
        },
        {
          messageCode: 'Product change request email was sent',
          endpoint: '/process-action',
          type: 'post',
        }
      )
      .then((response) => {
        self.setState({ showRequestChangesModal: false, pending: false, currentRecord: {} });
      })
      .catch((err) => {
        self.setState({ showRequestChangesModal: false, pending: false, currentRecord: {} });
      });
  }

  render() {
     if(this.props.appData.FeatureFlags.initialData) {
      return null;
    }
    return (
      <div className="seller-products-list-page">
        {this.state.currentScreen == 'ProductsTable' && (
          <div>
            {this.state.sellerProducts !== 'dataNotReceived' &&
              _.get(this.props.userReducer, ['seller', '_id'], false) && (
                <div
                  className="top20"
                  ref={(div) => {
                    this.pageContent = div;
                  }}
                >
                  {this.displayCurrentBalance()}

                  <Row className="top10 left0 right0">
                    <Col xs={3} className="font-size-20 top20 navyBlue bot20">
                      Product Listings
                    </Col>

                    {this.state.estimatedTimeToProcessItems && (
                      <Col xs={9} className="font-size-20 top20 navyBlue bot20">
                        Estimated time to process your items:{' '}
                        {this.state.estimatedTimeToProcessItems}
                      </Col>
                    )}
                  </Row>
                 {this.state.requestPending &&  <div className="pending-box"></div>}
                  <SellerProductsSearchBox
                    ref={(searchBox) => {
                      if (searchBox && !this.searchBox) {
                        this.searchBox = searchBox;
                        this.search();
                      }
                    }}
                    searchType={this.state.searchType}
                    onSearchTypeChange={(searchType)=> {
                     this.setState({requestPending:true},()=> {
                      this.search({searchType});
                     });
                    }}
                    search={this.search.bind(this)}
                  />

                  <SellerProductsListTable
                     onSortChange={this.onSortChange.bind(this)}
                    showProductDetailsModal={this.showProductDetailsModal.bind(this)}
                    showProductPreviewModal={this.showProductPreviewModal.bind(this)}
                    showRequestChangesModal={this.showRequestChangesModal.bind(this)}
                    sellerProducts={this.state.sellerProducts}
                    publishProduct={this.publishProduct.bind(this)}
                    searchType={this.state.searchType}
                    search={this.search.bind(this)}
                    {...this.props}
                  ></SellerProductsListTable>
                  { this.props.appData.FeatureFlags.SIIPEnabled &&
                    (<div className="seller-info-text"   > Please note, the pricing on our website may vary
                      from the price listed here to account for handling fees.
                      Your payout will be based on this listing price. </div>) }
                  <PaginationBox
                    currentPage={
                      _.isUndefined(queryString.parse(this.props.location.search).page)
                        ? 0
                        : parseInt(queryString.parse(this.props.location.search).page) - 1
                    }
                    perPage={5}
                    ref={'pagination'}
                    total={this.state.sellerProductsTotal}
                    search={this.search.bind(this)}
                  ></PaginationBox>

                  <div className="clearfix pbot20"></div>

                  {_.get(this.searchBox, 'state.currentSearchType') == 'Sold' &&
                    this.displayTransactionsTable()}
                </div>
              )}
          </div>
        )}

        {this.state.currentScreen == 'PayoutRequestForm' && this.displayPayoutRequestForm()}
        {this.state.currentScreen == 'PayoutRequestConfirmation' &&
          this.displayPayoutRequestConfirmation()}
        {this.state.currentScreen == 'PayoutRequestSuccess' && this.displayPayoutRequestSuccess()}

        <Modal
          show={this.state.showProductDetailsModal}
          onHide={() =>
            this.setState({
              showProductDetailsModal: false,
            })
          }
        >
          <Modal.Header closeButton>
            <Modal.Title>{''}</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div>
              <Row className="bot20">
                <Col md={12} sm={12} xs={12} style={{ textAlign: 'justify' }}>
                  <div className="bot10 font-size-17">{this.state.ProductDetailsMessage}</div>
                </Col>
              </Row>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Row className="left0">
              <Col md={12} sm={12} xs={12} className="pright0">
                <Button
                  className="pull-right btn right20 btn-primary"
                  type="button"
                  onClick={() =>
                    this.setState({
                      showProductDetailsModal: false,
                    })
                  }
                >
                  OK
                </Button>
              </Col>
            </Row>
          </Modal.Footer>
        </Modal>

        <Modal
          show={this.state.showRequestChangesModal}
          onHide={() =>
            this.setState({
              showRequestChangesModal: false,
            })
          }
        >
          <Modal.Header closeButton>
            <Modal.Title>{_.get(this.state.currentRecord, 'ProductName', '')}</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Row className="bot20">
              <Col md={12} sm={12} xs={12} style={{ textAlign: 'justify' }}>
                <FormGroup>
                  <ControlLabel>Changes</ControlLabel>
                  <FormControl
                    componentClass="textarea"
                    rows="4"
                    onChange={(e) =>
                      this.setState({
                        currentRecord: {
                          ...this.state.currentRecord,
                          RequestedChanges: e.target.value,
                        },
                      })
                    }
                    value={this.state.currentRecord.RequestedChanges}
                    placeholder=""
                  />
                </FormGroup>
              </Col>
            </Row>
          </Modal.Body>

          <Modal.Footer>
            <Row className="left0">
              <Col md={12} sm={12} xs={12} className="pright0">
                <Button
                  disabled={this.state.pending}
                  className="pull-right btn right20 btn-primary"
                  type="button"
                  onClick={() => {
                    this.setState(
                      {
                        pending: true,
                      },
                      function () {
                        this.sendProductRequestChangesEmail();
                      }
                    );
                  }}
                >
                  Send
                </Button>
              </Col>
            </Row>
          </Modal.Footer>
        </Modal>

        <Modal
          className="product-preview-modal"
          show={this.state.showProductPreviewModal}
          onHide={() =>
            this.setState({
              showProductPreviewModal: false,
            })
          }
        >
          <Modal.Header closeButton>
            <Modal.Title>{this.state.currentRecord.ProductName}</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="preview-images">
              {_.size(this.state.currentRecord.Images) > 0 ? (
                <ImageGallery
                  showFullscreenButton={false}
                  items={this.state.currentRecord.Images}
                />
              ) : (
                <img
                  src={
                    (config.getEnvironmentName() == 'local' ? 'http://localhost:3037' : '') +
                    '/theme/assets/no-image-placeholder.png'
                  }
                />
              )}
            </div>

            <div className="preview-content">
              <div className="preview-content__box --title top20 bot20">
                <span className="">{this.state.currentRecord.ProductName}</span>
              </div>

              <div className="preview-content__box --price bot10">
                <span className="">
                  {formatNumbers.formatMoney(this.state.currentRecord.Price)}
                </span>
              </div>

              <div className="preview-content__box --original-price bot20">
                <ControlLabel className="right10">Retails NEW for:</ControlLabel>
                <span className="">
                  {formatNumbers.formatMoney(this.state.currentRecord.OriginalPrice)}
                </span>
              </div>

              <div className="preview-content__box --original-price bot20">
                <ControlLabel className="right10">Condition:</ControlLabel>
                <span className="">{this.state.currentRecord.Condition}</span>
              </div>

              {this.state.currentRecord.Details !== '' && (
                <div className="preview-content__box --original-price bot20">
                  <ControlLabel className="right10">Condition details:</ControlLabel>
                  <span className="">{this.state.currentRecord.Details}</span>
                </div>
              )}

              <div className="preview-content__box --description bot20">
                <ControlLabel className="right10">Tell Me More...</ControlLabel>
                <div className="description-text-box">
                  <div className="description-text">"{this.state.currentRecord.Description}"</div>
                </div>
              </div>

              <div className="preview-content__box --original-price bot20">
                <ControlLabel className="bot0 right10">Tags:</ControlLabel>
                <span className="">
                  {_.get(this.state.currentRecord, 'ProductTags', []).join(', ')}
                </span>
              </div>

              {!this.state.currentRecord.published && (
                <Button
                  className="pull-right btn right20 btn-primary"
                  type="button"
                  onClick={() => this.publishProduct(this.state.currentRecord._id)}
                >
                  Publish
                </Button>
              )}
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Row className="left0">
              <Col md={12} sm={12} xs={12} className="pright0">
                <Button
                  className="pull-right btn right20 btn-primary"
                  type="button"
                  onClick={() =>
                    this.setState({
                      showProductPreviewModal: false,
                    })
                  }
                >
                  OK
                </Button>
              </Col>
            </Row>
          </Modal.Footer>
        </Modal>

        <Modal
          onExited={(e) => this.setState({ showWaitProcessingModal: false })}
          show={this.state.showWaitProcessingModal}
          onHide={(e) => this.setState({ showWaitProcessingModal: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {
                'Please do not close this window until we have confirmed your funds have successfully transferred to your bank.'
              }
            </Modal.Title>
          </Modal.Header>
        </Modal>

        {this.state.pending && !this.state.showWaitProcessingModal && (
          <div className="pending-box"></div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state, props) {
  return {
    userReducer: state.userReducer,
     appData: state.appData,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ makeRequest, dispatchAction, displayMessage }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SellerProductsPage);
